/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据观演人ids查询观演人信息列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  viewerIds: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.Commonly>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/viewers/${viewerIds}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
